export default __webpack_public_path__ + "static/media/Aliant.1f74714b.png";